import { Component, ElementRef, EventEmitter, Inject, Input, OnInit, Output, ViewChild, inject } from '@angular/core';
import { Testbed } from 'src/app/model/testbed';
import { MatAutocomplete } from '@angular/material/autocomplete';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import FuzzySearch from 'fuzzy-search';
import { ApiResponse } from 'src/app/classes/api-response';
import { Tester } from 'src/app/model/tester';
import { ContractsService } from 'src/app/services/contracts.service';
import { SnackService } from 'src/app/services/snack.service';
import { UsersService } from 'src/app/services/users.service';
import { isString, merge } from 'lodash-es';
import { TestbedsService } from 'src/app/services/testbeds.service';
import { Contract } from 'src/app/model/contract';

@Component({
  selector: 'aw-add-testers-to-testbed',
  templateUrl: './add-testers-to-testbed.component.html',
  styleUrls: ['./add-testers-to-testbed.component.scss']
})
export class AddTestersToTestbedComponent implements OnInit {

  @Output() saved = new EventEmitter<void>();
  @Output() canceled = new EventEmitter<void>();
  loadingTesters = false;
  saving = false;
  generalError?: ApiResponse;


  selectedTesters: Tester[] = [];
  filteredTesters: Tester[] = [];
  allPossibleTesters: Tester[] = [];
  @Input() inputString = '';
  @ViewChild('in') inputField: ElementRef;
  @ViewChild('autocomplete') autocompleteField: MatAutocomplete;
  private fuzzySearcher: FuzzySearch<Tester>;

  _testbed = new Testbed();
  _contract = new Contract();

  @Input() set testbed(value: any) {
    this._testbed = merge(new Testbed(), value.testbed);
  }

  @Input() set data(value: any) {
    this._testbed = merge(new Testbed(), value.testbed);
    this._contract = merge(new Contract(), value.testbed);;
  }

  constructor(
    private snackService: SnackService,
    private usersService: UsersService,
    private testbedsService: TestbedsService,
    private contractService: ContractsService,
    @Inject(MAT_DIALOG_DATA) public injectedData: any,
  ) {
    this.loadingTesters = true;
    console.log(this._testbed)
    this.usersService.getAllTestersByCompany(injectedData.testbed.company.id).subscribe(testers => {

      if (injectedData.testbed.testers) {
        let ids = injectedData.testbed.testers.map(tester => tester.id);
        testers = testers.filter((testers) => !ids.includes(testers.id));
      }

      this.allPossibleTesters = testers;

      this.fuzzySearcher = new FuzzySearch(this.allPossibleTesters, ["firstName", "lastName", "email"], { caseSensitive: false, sort: true });
      this.sortAlphabeticallyByLastName(this.allPossibleTesters);
      this.filteredTesters = testers;
      this.loadingTesters = false;

      if (!this._testbed.id)
        throw Error("There was a problem with the injection of the box");

      this._contract = this.injectedData.contract;

      console.log(this._contract);
      
    });

  }

  ngOnInit(): void {
    throw new Error('Method not implemented.');
  }

  private sortAlphabeticallyByLastName(arr: Tester[]) {
    arr.sort((a, b) => {
      if (a && b && a.lastName && b.lastName) {
        return a.lastName.toLowerCase().localeCompare(b.lastName.toLowerCase());
      }
      else
        return 0;
    });
  }

  showFilteredData() {
    this.filteredTesters = this.allPossibleTesters;
    if (isString(this.inputString)) {
      let string: string = this.inputString.trim();
      string = this.inputString.toLowerCase();
      const separatedString: string[] = string.split(' ');
      const testerSet: Set<Tester> = new Set<Tester>();
      separatedString.forEach(substring => {
        const subSet = this.fuzzySearcher.search(substring);
        subSet.forEach(tester => {
          testerSet.add(tester);
        });
      });
      this.filteredTesters = Array.from(testerSet);
    }
  }

  onOptionClicked(tester: Tester) {
    if (tester) {
      if (!this.selectedTesters.includes(tester)) {
        this.selectedTesters.push(tester);
        this.allPossibleTesters.splice(this.allPossibleTesters.indexOf(tester), 1);
        this.resetInput();
      }
      else this.snackService.error("User already selected");
    }
  }

  removeChip(tester: Tester) {
    this.selectedTesters.splice(this.selectedTesters.indexOf(tester), 1);
    this.allPossibleTesters.push(tester);
    this.sortAlphabeticallyByLastName(this.allPossibleTesters);
    this.showFilteredData();
  }

  resetInput() {
    this.inputField.nativeElement.value = '';
    this.inputString = "";
    this.showFilteredData();
    this.inputField.nativeElement.blur();
    setTimeout(() => {
      this.inputField.nativeElement.focus();
    }, 0);
  }

  addTesters(): void {
    this.saving = true;
    console.log(this.selectedTesters, this._testbed.id, this._contract.id);
    this.usersService.addTestersToTestbed(this.selectedTesters, this._testbed.id, this._contract.id)
    .subscribe(
      () => {
        this.saving = false;
        if (this.selectedTesters)
          this.selectedTesters.forEach((tester: Tester) => {
            this.injectedData.testbed.testers?.push(tester);
          })
        this.snackService.success('Testers associated!');
        this.saved.emit();
      },
      error => {
        this.saving = false;
        this.snackService.error(error.message);
        this.generalError = error;
      }
    );
  }

}
